import { default as _91environmentId_93okwuoMZxipMeta } from "/app/pages/connection-limit/[environmentId].vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as index64GoleNCL5Meta } from "/app/pages/root/connections/index.vue?macro=true";
import { default as indexExZ3BsW40nMeta } from "/app/pages/root/enterprise/index.vue?macro=true";
import { default as indexTrkMA31524Meta } from "/app/pages/root/history/index.vue?macro=true";
import { default as indexifdWPXkEnrMeta } from "/app/pages/root/index.vue?macro=true";
import { default as indexi6i0PJCLw3Meta } from "/app/pages/root/workspaces/[workspaceId]/index.vue?macro=true";
import { default as indexHQL1T4OK4pMeta } from "/app/pages/root/workspaces/index.vue?macro=true";
import { default as rootThfCCCXF89Meta } from "/app/pages/root.vue?macro=true";
import { default as routesMidTDJNZAKMeta } from "/app/pages/routes.vue?macro=true";
import { default as detaildjGgnQU6KtMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/aggregates/detail.vue?macro=true";
import { default as indexJfgJEFUcmVMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/aggregates/index.vue?macro=true";
import { default as aggregatesTDW5EQhqooMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/aggregates.vue?macro=true";
import { default as detailtim1wm6FqTMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/applications/detail.vue?macro=true";
import { default as indexv0A80YXLAmMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/applications/index.vue?macro=true";
import { default as applicationsufkW8lR1mfMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/applications.vue?macro=true";
import { default as flowCWCo0FdOHQMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/flow.vue?macro=true";
import { default as detailuBPb1EYZXCMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/handlers/detail.vue?macro=true";
import { default as indexo6dcGFFj6YMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/handlers/index.vue?macro=true";
import { default as handlersI0elVZlhreMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/handlers.vue?macro=true";
import { default as indexx9btbHgrIxMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/index.vue?macro=true";
import { default as conditions19LgI34tLcMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/monitoring/conditions.vue?macro=true";
import { default as integrationslHQCB6VvhJMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/monitoring/integrations.vue?macro=true";
import { default as monitoringcw39jao9HPMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/monitoring.vue?macro=true";
import { default as detailSsedbJvK9sMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/processor/detail.vue?macro=true";
import { default as dlqNKNvXh6e1FMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/processor/dlq.vue?macro=true";
import { default as indexVHUR4aO42JMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/processor/index.vue?macro=true";
import { default as processorLzNinkIEANMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/processor.vue?macro=true";
import { default as indexbliILnfZA4Meta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/server/index.vue?macro=true";
import { default as debianXDiLitPBgiMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/debian.vue?macro=true";
import { default as dockerqhHCIuw49mMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/docker.vue?macro=true";
import { default as downloadfgd04ItWqBMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/download.vue?macro=true";
import { default as indexuk5beF54cyMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/index.vue?macro=true";
import { default as kuberneteso13qOb6TgrMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/kubernetes.vue?macro=true";
import { default as ubuntuvIYdCZCwBbMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/ubuntu.vue?macro=true";
import { default as installx6iOZhGvtRMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install.vue?macro=true";
import { default as activityDwkRHxS7XVMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/settings/activity.vue?macro=true";
import { default as generalvWRL2xfAQUMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/settings/general.vue?macro=true";
import { default as tokensKGqDIY66QCMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/settings/tokens.vue?macro=true";
import { default as settingsUfLbKp3yD7Meta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/settings.vue?macro=true";
import { default as compare3GTLSrjpiqMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/subscription/compare.vue?macro=true";
import { default as indexvH6MBEPZoWMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/subscription/index.vue?macro=true";
import { default as subscriptionwbYPKS5cACMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/subscription.vue?macro=true";
import { default as usaget2JmAoQlNgMeta } from "/app/pages/workspace/[workspaceId]/env/[environmentId]/usage.vue?macro=true";
import { default as envKv7NhbMLEsMeta } from "/app/pages/workspace/[workspaceId]/env.vue?macro=true";
import { default as index8LIIAL2QbNMeta } from "/app/pages/workspace/[workspaceId]/index.vue?macro=true";
import { default as _91workspaceId_93kYAAeQTP7lMeta } from "/app/pages/workspace/[workspaceId].vue?macro=true";
export default [
  {
    name: _91environmentId_93okwuoMZxipMeta?.name ?? "connection-limit-environmentId",
    path: _91environmentId_93okwuoMZxipMeta?.path ?? "/connection-limit/:environmentId()",
    meta: _91environmentId_93okwuoMZxipMeta || {},
    alias: _91environmentId_93okwuoMZxipMeta?.alias || [],
    redirect: _91environmentId_93okwuoMZxipMeta?.redirect,
    component: () => import("/app/pages/connection-limit/[environmentId].vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: rootThfCCCXF89Meta?.name ?? undefined,
    path: rootThfCCCXF89Meta?.path ?? "/root",
    meta: rootThfCCCXF89Meta || {},
    alias: rootThfCCCXF89Meta?.alias || [],
    redirect: rootThfCCCXF89Meta?.redirect,
    component: () => import("/app/pages/root.vue").then(m => m.default || m),
    children: [
  {
    name: index64GoleNCL5Meta?.name ?? "root-connections",
    path: index64GoleNCL5Meta?.path ?? "connections",
    meta: index64GoleNCL5Meta || {},
    alias: index64GoleNCL5Meta?.alias || [],
    redirect: index64GoleNCL5Meta?.redirect,
    component: () => import("/app/pages/root/connections/index.vue").then(m => m.default || m)
  },
  {
    name: indexExZ3BsW40nMeta?.name ?? "root-enterprise",
    path: indexExZ3BsW40nMeta?.path ?? "enterprise",
    meta: indexExZ3BsW40nMeta || {},
    alias: indexExZ3BsW40nMeta?.alias || [],
    redirect: indexExZ3BsW40nMeta?.redirect,
    component: () => import("/app/pages/root/enterprise/index.vue").then(m => m.default || m)
  },
  {
    name: indexTrkMA31524Meta?.name ?? "root-history",
    path: indexTrkMA31524Meta?.path ?? "history",
    meta: indexTrkMA31524Meta || {},
    alias: indexTrkMA31524Meta?.alias || [],
    redirect: indexTrkMA31524Meta?.redirect,
    component: () => import("/app/pages/root/history/index.vue").then(m => m.default || m)
  },
  {
    name: indexifdWPXkEnrMeta?.name ?? "root",
    path: indexifdWPXkEnrMeta?.path ?? "",
    meta: indexifdWPXkEnrMeta || {},
    alias: indexifdWPXkEnrMeta?.alias || [],
    redirect: indexifdWPXkEnrMeta?.redirect,
    component: () => import("/app/pages/root/index.vue").then(m => m.default || m)
  },
  {
    name: indexi6i0PJCLw3Meta?.name ?? "root-workspaces-workspaceId",
    path: indexi6i0PJCLw3Meta?.path ?? "workspaces/:workspaceId()",
    meta: indexi6i0PJCLw3Meta || {},
    alias: indexi6i0PJCLw3Meta?.alias || [],
    redirect: indexi6i0PJCLw3Meta?.redirect,
    component: () => import("/app/pages/root/workspaces/[workspaceId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexHQL1T4OK4pMeta?.name ?? "root-workspaces",
    path: indexHQL1T4OK4pMeta?.path ?? "workspaces",
    meta: indexHQL1T4OK4pMeta || {},
    alias: indexHQL1T4OK4pMeta?.alias || [],
    redirect: indexHQL1T4OK4pMeta?.redirect,
    component: () => import("/app/pages/root/workspaces/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: routesMidTDJNZAKMeta?.name ?? "routes",
    path: routesMidTDJNZAKMeta?.path ?? "/routes",
    meta: routesMidTDJNZAKMeta || {},
    alias: routesMidTDJNZAKMeta?.alias || [],
    redirect: routesMidTDJNZAKMeta?.redirect,
    component: () => import("/app/pages/routes.vue").then(m => m.default || m)
  },
  {
    name: _91workspaceId_93kYAAeQTP7lMeta?.name ?? undefined,
    path: _91workspaceId_93kYAAeQTP7lMeta?.path ?? "/workspace/:workspaceId()",
    meta: _91workspaceId_93kYAAeQTP7lMeta || {},
    alias: _91workspaceId_93kYAAeQTP7lMeta?.alias || [],
    redirect: _91workspaceId_93kYAAeQTP7lMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId].vue").then(m => m.default || m),
    children: [
  {
    name: envKv7NhbMLEsMeta?.name ?? "workspace-workspaceId-env",
    path: envKv7NhbMLEsMeta?.path ?? "env",
    meta: envKv7NhbMLEsMeta || {},
    alias: envKv7NhbMLEsMeta?.alias || [],
    redirect: envKv7NhbMLEsMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env.vue").then(m => m.default || m),
    children: [
  {
    name: aggregatesTDW5EQhqooMeta?.name ?? undefined,
    path: aggregatesTDW5EQhqooMeta?.path ?? ":environmentId()/aggregates",
    meta: aggregatesTDW5EQhqooMeta || {},
    alias: aggregatesTDW5EQhqooMeta?.alias || [],
    redirect: aggregatesTDW5EQhqooMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/aggregates.vue").then(m => m.default || m),
    children: [
  {
    name: detaildjGgnQU6KtMeta?.name ?? "workspace-workspaceId-env-environmentId-aggregates-detail",
    path: detaildjGgnQU6KtMeta?.path ?? "detail",
    meta: detaildjGgnQU6KtMeta || {},
    alias: detaildjGgnQU6KtMeta?.alias || [],
    redirect: detaildjGgnQU6KtMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/aggregates/detail.vue").then(m => m.default || m)
  },
  {
    name: indexJfgJEFUcmVMeta?.name ?? "workspace-workspaceId-env-environmentId-aggregates",
    path: indexJfgJEFUcmVMeta?.path ?? "",
    meta: indexJfgJEFUcmVMeta || {},
    alias: indexJfgJEFUcmVMeta?.alias || [],
    redirect: indexJfgJEFUcmVMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/aggregates/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: applicationsufkW8lR1mfMeta?.name ?? undefined,
    path: applicationsufkW8lR1mfMeta?.path ?? ":environmentId()/applications",
    meta: applicationsufkW8lR1mfMeta || {},
    alias: applicationsufkW8lR1mfMeta?.alias || [],
    redirect: applicationsufkW8lR1mfMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/applications.vue").then(m => m.default || m),
    children: [
  {
    name: detailtim1wm6FqTMeta?.name ?? "workspace-workspaceId-env-environmentId-applications-detail",
    path: detailtim1wm6FqTMeta?.path ?? "detail",
    meta: detailtim1wm6FqTMeta || {},
    alias: detailtim1wm6FqTMeta?.alias || [],
    redirect: detailtim1wm6FqTMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/applications/detail.vue").then(m => m.default || m)
  },
  {
    name: indexv0A80YXLAmMeta?.name ?? "workspace-workspaceId-env-environmentId-applications",
    path: indexv0A80YXLAmMeta?.path ?? "",
    meta: indexv0A80YXLAmMeta || {},
    alias: indexv0A80YXLAmMeta?.alias || [],
    redirect: indexv0A80YXLAmMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/applications/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: flowCWCo0FdOHQMeta?.name ?? "workspace-workspaceId-env-environmentId-flow",
    path: flowCWCo0FdOHQMeta?.path ?? ":environmentId()/flow",
    meta: flowCWCo0FdOHQMeta || {},
    alias: flowCWCo0FdOHQMeta?.alias || [],
    redirect: flowCWCo0FdOHQMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/flow.vue").then(m => m.default || m)
  },
  {
    name: handlersI0elVZlhreMeta?.name ?? undefined,
    path: handlersI0elVZlhreMeta?.path ?? ":environmentId()/handlers",
    meta: handlersI0elVZlhreMeta || {},
    alias: handlersI0elVZlhreMeta?.alias || [],
    redirect: handlersI0elVZlhreMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/handlers.vue").then(m => m.default || m),
    children: [
  {
    name: detailuBPb1EYZXCMeta?.name ?? "workspace-workspaceId-env-environmentId-handlers-detail",
    path: detailuBPb1EYZXCMeta?.path ?? "detail",
    meta: detailuBPb1EYZXCMeta || {},
    alias: detailuBPb1EYZXCMeta?.alias || [],
    redirect: detailuBPb1EYZXCMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/handlers/detail.vue").then(m => m.default || m)
  },
  {
    name: indexo6dcGFFj6YMeta?.name ?? "workspace-workspaceId-env-environmentId-handlers",
    path: indexo6dcGFFj6YMeta?.path ?? "",
    meta: indexo6dcGFFj6YMeta || {},
    alias: indexo6dcGFFj6YMeta?.alias || [],
    redirect: indexo6dcGFFj6YMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/handlers/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexx9btbHgrIxMeta?.name ?? "workspace-workspaceId-env-environmentId",
    path: indexx9btbHgrIxMeta?.path ?? ":environmentId()",
    meta: indexx9btbHgrIxMeta || {},
    alias: indexx9btbHgrIxMeta?.alias || [],
    redirect: indexx9btbHgrIxMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/index.vue").then(m => m.default || m)
  },
  {
    name: monitoringcw39jao9HPMeta?.name ?? "workspace-workspaceId-env-environmentId-monitoring",
    path: monitoringcw39jao9HPMeta?.path ?? ":environmentId()/monitoring",
    meta: monitoringcw39jao9HPMeta || {},
    alias: monitoringcw39jao9HPMeta?.alias || [],
    redirect: monitoringcw39jao9HPMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/monitoring.vue").then(m => m.default || m),
    children: [
  {
    name: conditions19LgI34tLcMeta?.name ?? "workspace-workspaceId-env-environmentId-monitoring-conditions",
    path: conditions19LgI34tLcMeta?.path ?? "conditions",
    meta: conditions19LgI34tLcMeta || {},
    alias: conditions19LgI34tLcMeta?.alias || [],
    redirect: conditions19LgI34tLcMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/monitoring/conditions.vue").then(m => m.default || m)
  },
  {
    name: integrationslHQCB6VvhJMeta?.name ?? "workspace-workspaceId-env-environmentId-monitoring-integrations",
    path: integrationslHQCB6VvhJMeta?.path ?? "integrations",
    meta: integrationslHQCB6VvhJMeta || {},
    alias: integrationslHQCB6VvhJMeta?.alias || [],
    redirect: integrationslHQCB6VvhJMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/monitoring/integrations.vue").then(m => m.default || m)
  }
]
  },
  {
    name: processorLzNinkIEANMeta?.name ?? undefined,
    path: processorLzNinkIEANMeta?.path ?? ":environmentId()/processor",
    meta: processorLzNinkIEANMeta || {},
    alias: processorLzNinkIEANMeta?.alias || [],
    redirect: processorLzNinkIEANMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/processor.vue").then(m => m.default || m),
    children: [
  {
    name: detailSsedbJvK9sMeta?.name ?? "workspace-workspaceId-env-environmentId-processor-detail",
    path: detailSsedbJvK9sMeta?.path ?? "detail",
    meta: detailSsedbJvK9sMeta || {},
    alias: detailSsedbJvK9sMeta?.alias || [],
    redirect: detailSsedbJvK9sMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/processor/detail.vue").then(m => m.default || m)
  },
  {
    name: dlqNKNvXh6e1FMeta?.name ?? "workspace-workspaceId-env-environmentId-processor-dlq",
    path: dlqNKNvXh6e1FMeta?.path ?? "dlq",
    meta: dlqNKNvXh6e1FMeta || {},
    alias: dlqNKNvXh6e1FMeta?.alias || [],
    redirect: dlqNKNvXh6e1FMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/processor/dlq.vue").then(m => m.default || m)
  },
  {
    name: indexVHUR4aO42JMeta?.name ?? "workspace-workspaceId-env-environmentId-processor",
    path: indexVHUR4aO42JMeta?.path ?? "",
    meta: indexVHUR4aO42JMeta || {},
    alias: indexVHUR4aO42JMeta?.alias || [],
    redirect: indexVHUR4aO42JMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/processor/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexbliILnfZA4Meta?.name ?? "workspace-workspaceId-env-environmentId-server",
    path: indexbliILnfZA4Meta?.path ?? ":environmentId()/server",
    meta: indexbliILnfZA4Meta || {},
    alias: indexbliILnfZA4Meta?.alias || [],
    redirect: indexbliILnfZA4Meta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/server/index.vue").then(m => m.default || m)
  },
  {
    name: installx6iOZhGvtRMeta?.name ?? undefined,
    path: installx6iOZhGvtRMeta?.path ?? ":environmentId()/server/install",
    meta: installx6iOZhGvtRMeta || {},
    alias: installx6iOZhGvtRMeta?.alias || [],
    redirect: installx6iOZhGvtRMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install.vue").then(m => m.default || m),
    children: [
  {
    name: debianXDiLitPBgiMeta?.name ?? "workspace-workspaceId-env-environmentId-server-install-debian",
    path: debianXDiLitPBgiMeta?.path ?? "debian",
    meta: debianXDiLitPBgiMeta || {},
    alias: debianXDiLitPBgiMeta?.alias || [],
    redirect: debianXDiLitPBgiMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/debian.vue").then(m => m.default || m)
  },
  {
    name: dockerqhHCIuw49mMeta?.name ?? "workspace-workspaceId-env-environmentId-server-install-docker",
    path: dockerqhHCIuw49mMeta?.path ?? "docker",
    meta: dockerqhHCIuw49mMeta || {},
    alias: dockerqhHCIuw49mMeta?.alias || [],
    redirect: dockerqhHCIuw49mMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/docker.vue").then(m => m.default || m)
  },
  {
    name: downloadfgd04ItWqBMeta?.name ?? "workspace-workspaceId-env-environmentId-server-install-download",
    path: downloadfgd04ItWqBMeta?.path ?? "download",
    meta: downloadfgd04ItWqBMeta || {},
    alias: downloadfgd04ItWqBMeta?.alias || [],
    redirect: downloadfgd04ItWqBMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/download.vue").then(m => m.default || m)
  },
  {
    name: indexuk5beF54cyMeta?.name ?? "workspace-workspaceId-env-environmentId-server-install",
    path: indexuk5beF54cyMeta?.path ?? "",
    meta: indexuk5beF54cyMeta || {},
    alias: indexuk5beF54cyMeta?.alias || [],
    redirect: indexuk5beF54cyMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/index.vue").then(m => m.default || m)
  },
  {
    name: kuberneteso13qOb6TgrMeta?.name ?? "workspace-workspaceId-env-environmentId-server-install-kubernetes",
    path: kuberneteso13qOb6TgrMeta?.path ?? "kubernetes",
    meta: kuberneteso13qOb6TgrMeta || {},
    alias: kuberneteso13qOb6TgrMeta?.alias || [],
    redirect: kuberneteso13qOb6TgrMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/kubernetes.vue").then(m => m.default || m)
  },
  {
    name: ubuntuvIYdCZCwBbMeta?.name ?? "workspace-workspaceId-env-environmentId-server-install-ubuntu",
    path: ubuntuvIYdCZCwBbMeta?.path ?? "ubuntu",
    meta: ubuntuvIYdCZCwBbMeta || {},
    alias: ubuntuvIYdCZCwBbMeta?.alias || [],
    redirect: ubuntuvIYdCZCwBbMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/server/install/ubuntu.vue").then(m => m.default || m)
  }
]
  },
  {
    name: settingsUfLbKp3yD7Meta?.name ?? "workspace-workspaceId-env-environmentId-settings",
    path: settingsUfLbKp3yD7Meta?.path ?? ":environmentId()/settings",
    meta: settingsUfLbKp3yD7Meta || {},
    alias: settingsUfLbKp3yD7Meta?.alias || [],
    redirect: settingsUfLbKp3yD7Meta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/settings.vue").then(m => m.default || m),
    children: [
  {
    name: activityDwkRHxS7XVMeta?.name ?? "workspace-workspaceId-env-environmentId-settings-activity",
    path: activityDwkRHxS7XVMeta?.path ?? "activity",
    meta: activityDwkRHxS7XVMeta || {},
    alias: activityDwkRHxS7XVMeta?.alias || [],
    redirect: activityDwkRHxS7XVMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/settings/activity.vue").then(m => m.default || m)
  },
  {
    name: generalvWRL2xfAQUMeta?.name ?? "workspace-workspaceId-env-environmentId-settings-general",
    path: generalvWRL2xfAQUMeta?.path ?? "general",
    meta: generalvWRL2xfAQUMeta || {},
    alias: generalvWRL2xfAQUMeta?.alias || [],
    redirect: generalvWRL2xfAQUMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/settings/general.vue").then(m => m.default || m)
  },
  {
    name: tokensKGqDIY66QCMeta?.name ?? "workspace-workspaceId-env-environmentId-settings-tokens",
    path: tokensKGqDIY66QCMeta?.path ?? "tokens",
    meta: tokensKGqDIY66QCMeta || {},
    alias: tokensKGqDIY66QCMeta?.alias || [],
    redirect: tokensKGqDIY66QCMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/settings/tokens.vue").then(m => m.default || m)
  }
]
  },
  {
    name: subscriptionwbYPKS5cACMeta?.name ?? undefined,
    path: subscriptionwbYPKS5cACMeta?.path ?? ":environmentId()/subscription",
    meta: subscriptionwbYPKS5cACMeta || {},
    alias: subscriptionwbYPKS5cACMeta?.alias || [],
    redirect: subscriptionwbYPKS5cACMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/subscription.vue").then(m => m.default || m),
    children: [
  {
    name: compare3GTLSrjpiqMeta?.name ?? "workspace-workspaceId-env-environmentId-subscription-compare",
    path: compare3GTLSrjpiqMeta?.path ?? "compare",
    meta: compare3GTLSrjpiqMeta || {},
    alias: compare3GTLSrjpiqMeta?.alias || [],
    redirect: compare3GTLSrjpiqMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/subscription/compare.vue").then(m => m.default || m)
  },
  {
    name: indexvH6MBEPZoWMeta?.name ?? "workspace-workspaceId-env-environmentId-subscription",
    path: indexvH6MBEPZoWMeta?.path ?? "",
    meta: indexvH6MBEPZoWMeta || {},
    alias: indexvH6MBEPZoWMeta?.alias || [],
    redirect: indexvH6MBEPZoWMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/subscription/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usaget2JmAoQlNgMeta?.name ?? "workspace-workspaceId-env-environmentId-usage",
    path: usaget2JmAoQlNgMeta?.path ?? ":environmentId()/usage",
    meta: usaget2JmAoQlNgMeta || {},
    alias: usaget2JmAoQlNgMeta?.alias || [],
    redirect: usaget2JmAoQlNgMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/env/[environmentId]/usage.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index8LIIAL2QbNMeta?.name ?? "workspace-workspaceId",
    path: index8LIIAL2QbNMeta?.path ?? "",
    meta: index8LIIAL2QbNMeta || {},
    alias: index8LIIAL2QbNMeta?.alias || [],
    redirect: index8LIIAL2QbNMeta?.redirect,
    component: () => import("/app/pages/workspace/[workspaceId]/index.vue").then(m => m.default || m)
  }
]
  }
]